<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
    <BaseVeeForm :action="deleteFunnel" v-slot="formProps" class="mx-auto max-w-lg">
      <BaseCard @click.stop>
        <BaseCardHeader> Delete funnel </BaseCardHeader>
        <BaseCardBody>
          <p class="text-gray-600 mb-4">
            Are you sure you want to delete this funnel? Once an funnel is deleted, you want be able
            to recover it.
          </p>
        </BaseCardBody>
        <BaseCardFooter gray>
          <div class="flex space-x-2">
            <BaseButton
              primary
              :disabled="formProps.isPending || formProps.isRejected || formProps.invalid"
            >
              Delete Funnel
            </BaseButton>
            <BaseButton
              type="button"
              ghost
              :disabled="formProps.isPending"
              @click="$refs.modal.close()"
            >
              Cancel
            </BaseButton>
          </div>
        </BaseCardFooter>
      </BaseCard>
    </BaseVeeForm>
  </VModal>
</template>

<script>
import { funnelsClient } from '@/api/clients';

const props = {
  funnelId: {
    type: String,
    required: true,
  },
};

const methods = {
  async deleteFunnel() {
    try {
      await funnelsClient.destroy(this.funnelId);

      this.$emit('destroyed');

      this.$refs.modal.close();

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  name: 'FunnelDeleteModal',
  props,
  methods,
};
</script>
